import { buildQuery, parseQuery } from '@calendly/http-tools'

function getOmniAuthPath(provider, flow, parameters) {
  const requestParams = parseQuery(window.location.search)
  if (requestParams.forceAzureUpgrade && provider === 'azure_oauth2') {
    provider = 'azure2_oauth2'
  }

  const query = buildQuery({
    state: flow,
    ...parameters
  })
  return `/users/auth/${provider}?${query}`
}

export { getOmniAuthPath }
